import React from "react"
import { createRoot } from "react-dom/client"
import * as serviceWorker from "./serviceWorker"
import RouteConfig from "./pages/_router"
import { ApolloProvider } from "@apollo/client"
import { createClient } from "./graphql"
import { LoginContextProvider } from "./components/context/LoginContext"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.min.css"
import "./i18n"
import { LanguageContextProvider } from "./components/context/LanguageContext"
import { AntdLanguageProvider } from "./components/context/AntdLanguageProvider"
import { StyleProvider } from "@ant-design/cssinjs"
import { App } from "antd"

const client = createClient()

const root = createRoot(document.getElementById("root")!)
root.render(
  <LanguageContextProvider>
    <AntdLanguageProvider>
      <StyleProvider>
        <App>
          <ApolloProvider client={client}>
            <LoginContextProvider>
              <ToastContainer closeButton={false} />
              <RouteConfig />
            </LoginContextProvider>
          </ApolloProvider>
        </App>
      </StyleProvider>
    </AntdLanguageProvider>
  </LanguageContextProvider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
